import { Link } from 'react-router-dom'
import EmptyState from '@/components/common/EmptyState'
import { buttonVariants } from '@/components/ui/button'
import { useHomePath } from '@/pages/WorkspaceHome'

export default function NoAccess({ description }: { description?: string }) {
  const home = useHomePath()
  return (
    <EmptyState
      title="No access"
      description={description ?? 'Your role does not include this page. Ask an administrator if you need it.'}
      action={
        <Link to={home} className={buttonVariants({ variant: 'outline' })}>
          Back to home
        </Link>
      }
    />
  )
}
